export const normalizeFetchUsersResponse = response =>
    response.map(user => ({
        id: user.id,
        email: user.email,
        name: user.name,
        organizationId: user.organization_id,
        roles: user.roles,
        type: user.type,
        status: user.status,
        invitationExpired: user.invitation_expired,
        tokenExpiresAt: user.token_expires_at,
    }))
